// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"101":"a9fc5e94","273":"871ef45a","413":"5c858605","434":"80d02d35","507":"3d319e8b","921":"baed1b75","944":"88fc6d12"}[chunkId] + ".chunk.css";
};